import { render, staticRenderFns } from "./CorporateVendorViewCountReport.vue?vue&type=template&id=3867597a"
import script from "./CorporateVendorViewCountReport.vue?vue&type=script&lang=js"
export * from "./CorporateVendorViewCountReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports